<template>
  <PageContainer v-if="building" class="unit-breadcrumb">
    <!-- On a phone the app header carries the way back; the trail still says where the unit sits -->
    <PageBackNav
      v-if="screenMobile"
      :teleport-slot-id="headerTeleportSlot"
      @back-nav="router.push(buildingRoute(building.id))"
    />
    <Breadcrumbs :items="trail" />
  </PageContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { BreadcrumbItem, Breadcrumbs, PageBackNav, PageContainer, screenMobile } from '@tallo/design-system';
import { buildingRoute, portfolioRoute } from '@tallo/investor/navigation';
import { useBuildingQuery } from '@tallo/investor/property';

import { headerTeleportSlot } from '../../root/header-teleport-slot.const';

/** Where a unit sits: its portfolio, its building, then the unit itself */
const props = defineProps<{ buildingId: string; unitNumber: string | null }>();

const router = useRouter();
const { data: building } = useBuildingQuery(() => props.buildingId);

const trail = computed<BreadcrumbItem[]>(() => [
  {
    label: building.value?.portfolio?.name ?? 'All properties',
    to: portfolioRoute(building.value?.portfolio?.id, 'buildings'),
  },
  { label: building.value?.name ?? '', to: buildingRoute(props.buildingId) },
  { label: props.unitNumber ? `Unit ${props.unitNumber}` : 'Unit' },
]);
</script>

<style scoped lang="scss">
// The tab's page starts right under it, so only the trail's own room is taken
.unit-breadcrumb {
  padding-block-start: var(--t-spacing-md);
}
</style>
